module.exports = __webpack_public_path__ + "media/bg1.d55f7ee9.mp4";